import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';
import logger from 'redux-logger';

// const store = createStore(
//   rootReducer,
//   applyMiddleware(thunk)
// );

const store = createStore(rootReducer, applyMiddleware(thunk));

// const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(logger, thunk)));

export { store };
// const persistor = persistStore(store);

// export { store, persistor };
